export enum EtiquetasStyle {
  Programas = 'programas',
  Edicao = 'em-edicao',
  Revisao = 'em-revisao',
  Aprovacao = 'em-aprovacao',
  Finalizado = 'finalizado',
  Aprovado = 'aprovado',
  Excluido = 'excluido',
  Reprovado = 'reprovado',
  Cancelado = 'cancelado',
  OutlinePrimary = 'outline-primary',
  Orange = 'orange',
  OutlineDanger = 'outline-danger',
  OutlineDark = 'outline-dark',
  OutlineBlue = 'outline-blue',
  OutlineWarningDark = 'outline-warning-dark',
  Yellow = 'yellow',
}
